import { configure } from 'vee-validate'
import capitalize from 'lodash-es/capitalize'
import { i18n, replace } from './-i18n'

export default defineNuxtPlugin(({ vueApp }: any) => {
  vueApp.use(i18n)
  configure({
    generateMessage (context: any): any {
      const { field, rule } = context
      const { name, params } = rule
      return replace(
        i18n.global.t(`validations.${name}`, { field: i18n.global.t(`labels.${field}`, capitalize(field)) }, i18n.global.t('validations.invalid')),
        params
      )
    }
  })
  return {
    provide: {
      t: i18n.global.t
    }
  }
})
